<template>
  <v-card outlined height="100%">
    <v-card-text>
      <v-row>
        <v-col cols="4">
          <v-card outlined>
            <v-card-title>Backup erstellen</v-card-title>
            <v-card-text>
              Alle vorhandenen Tabellen werden als csv-Dateien exportiert.
              <br>Derzeit werden folgende Tabellen exportiert:
              <br>- Kontakte
              <br>- getränke
              <br>- Rechnungen
              <br>- Getränkelieferungen
              <br>- Getränkezählungen
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="primary--text" outlined @click="backupData()">Backup erstellen</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card outlined>
            <v-card-title>Adress-Export</v-card-title>
            <v-card-text>
              Aus der Kontaktliste werden verschiedenen Kontaktgruppen als einzelne csv-Dateien exportiert.
              <br>- BbrBbr Deutschland
              <br>- BbrBbr Ausland
              <br>- AHAH 
              <br>- Aktive
              <br>- HBV-Mitglieder
              <br>- Witwen
              <br>- Freundinnen und Damen
              <br>- Spefüxe und Gäste
              <br>- CV-Verbindungen
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="primary--text" outlined @click="adressExportData()">Exportieren</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card outlined>
            <v-card-title>Import</v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>    

    <v-divider></v-divider>
    <v-card-actions>
      
    </v-card-actions>
  </v-card>
</template>

<script>
import JSZip from 'jszip'
import FileSaver from 'file-saver'
import papa from 'papaparse'
export default {
  data () {
    return {
      showTemplate: false,
      template: {},
      istNeu: false,
      templateKategorien: ['Mail', 'Rechnung', 'Brief']
    }
  },
  computed: {
    templates () {
      return this.$store.getters['einstellungen/einstellung']('templates').templates
    }
  },
  methods: {
    backupData () {
      let tabellenData = []
      var zip = new JSZip()
      tabellenData.push({
        name: 'bbrbbr',
        data: this.$store.getters['bbrbbr/nurBbrbbr']
      })
      tabellenData.push({
        name: 'bierlieferungen',
        data: this.$store.state.bierlieferungen.bierlieferungen
      })
      tabellenData.push({
        name: 'getränke',
        data: this.$store.state.getranke.getranke
      })
      tabellenData.push({
        name: 'getränkestände',
        data: this.$store.state.getrankeStand.getrankeStande
      })
      tabellenData.push({
        name: 'rechnungen',
        data: this.$store.state.rechnungen.rechnungen
      })
      tabellenData.push({
        name: 'veranstaltungen',
        data: this.$store.state.veranstaltungen.veranstaltungen
      })
      tabellenData.forEach(item => {
        var csv = papa.unparse(item.data)
        var csvData = new Blob([csv], {type: 'text/csv;charset=utf-8;'})
        zip.file(item.name + '.csv', csvData)
      })
      zip.generateAsync({ type: 'blob' })
      .then(function (content) {
        // see FileSaver.js
        FileSaver.saveAs(content, 'example.zip')
      })
    },
    adressExportData () {
      let groups = {
        bbrbbr_deutschland: { name: 'bbrbbr_deutschland', data: [] },
        bbrbbr_ausland: { name: 'bbrbbr_ausland', data: [] },
        ahah: { name: 'ahah', data: [] },
        aktive: { name: 'aktive', data: [] },
        hbv_mitglieder: { name: 'hbv_mitglieder', data: [] },
        witwen: { name: 'witwen', data: [] },
        freundinnen_und_damen: { name: 'freundinnen_und_damen', data: [] },
        spefux_und_gast: { name: 'spefux_und_gast', data: [] },
        cv_verbindungen: { name: 'cv_verbindungen', data: [] }
      }
      this.$store.state.bbrbbr.bbrbbr.forEach(bbr => {
        switch (bbr.status) {
          case 'Spefux':
            groups.spefux_und_gast.data.push(bbr)
            break
          case 'Fux':
          case 'Aktiver':
          case 'Inaktiver in loco':
          case 'Inaktiver extra locum':
            groups.aktive.data.push(bbr)
            if (bbr.land === 'Deutschland') {
              groups.bbrbbr_deutschland.data.push(bbr)
            } else {
              groups.bbrbbr_ausland.data.push(bbr)
            }
            break
          case 'Alter Herr':
            groups.ahah.data.push(bbr)
            if (bbr.land === 'Deutschland') {
              groups.bbrbbr_deutschland.data.push(bbr)
            } else {
              groups.bbrbbr_ausland.data.push(bbr)
            }
            if (bbr.hbvBeitrag > 0) {
              groups.hbv_mitglieder.data.push(bbr)
            }
            break
          case 'Ehrenmitglieder':
            groups.ahah.data.push(bbr)
            if (bbr.land === 'Deutschland') {
              groups.bbrbbr_deutschland.data.push(bbr)
            } else {
              groups.bbrbbr_ausland.data.push(bbr)
            }
            break
          case 'Aktive Damen':
            groups.freundinnen_und_damen.data.push(bbr)
            break
          case 'Witwen':
            groups.witwen.data.push(bbr)
            break
          case 'CV-Verbindungen':
            groups.cv_verbindungen.data.push(bbr)
            break
          case 'Gast':
            groups.spefux_und_gast.data.push(bbr)
            break
        }
      })
      let tabellenData = []
      tabellenData.push(groups.bbrbbr_deutschland)
      tabellenData.push(groups.bbrbbr_ausland)
      tabellenData.push(groups.ahah)
      tabellenData.push(groups.aktive)
      tabellenData.push(groups.hbv_mitglieder)
      tabellenData.push(groups.witwen)
      tabellenData.push(groups.freundinnen_und_damen)
      tabellenData.push(groups.spefux_und_gast)
      tabellenData.push(groups.cv_verbindungen)
      var zip = new JSZip()
      tabellenData.forEach(item => {
        var csv = papa.unparse(item.data)
        var csvData = new Blob([csv], {type: 'text/csv;charset=utf-8;'})
        zip.file(item.name + '.csv', csvData)
      })
      zip.generateAsync({ type: 'blob' })
      .then(function (content) {
        FileSaver.saveAs(content, 'ripuaria_kontaktdaten.zip')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ImExport.vue?ba4aa6a6